// extracted by mini-css-extract-plugin
export default {"fancyInlineEdit":"FancyInlineEdit_fancyInlineEdit__cDTP5","fancyInlineEditInput":"FancyInlineEdit_fancyInlineEditInput__NliaT"};